export async function getBeneficiaries(beneficiariesRepository) {
  return beneficiariesRepository.get();
}
